import React, { useEffect, useState } from 'react';
import {
  InputCheckbox,
  InputText,
  IputDateMaterialUI
} from '../../components/inputs';
import { API_HOST } from '../../consts';
import Axios from 'axios';
import NavBreadCrumb from '../../containers/NavBreadCrumb';
import { FormContainer } from './styles/ReviewAplicationRedacaoStyles';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import InputNumber from '../../components/inputs/InputNumber';
import { get } from 'lodash';
import classnames from 'classnames';
import InputDecimal from '../../components/inputs/InputDecimal.js';

const CreateProjetoCorrecao = ({ match }) => {
  const [formValues, setFormValues] = useState([]);
  const [errors, setErrors] = useState([]);
  const [tema, setTema] = useState([]);
  const [convertedText, setConvertedText] = useState(tema.nome);

  const fetchTema = async (id) => {
    if (id) {
      try {
        const res = await Axios.get(`${API_HOST}/redacao_temas/temas/${id}`);
        setTema(res.data);
        setConvertedText(res.data.nome);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const renderErrorToast = (errors) => {
    const label = 'non_field_errors';
    const non_field_errors = get(errors, label, []);
    delete errors.non_field_errors;
    toast.error(
      <React.Fragment>
        {Object.keys(errors).length > 0 && (
          <p>Por favor, preencha os campos marcados como obrigatórios.</p>
        )}
        <ul>
          {non_field_errors.map((e) => (
            <li key={e}>{e}</li>
          ))}
        </ul>
      </React.Fragment>
    );
  };

  useEffect(() => {
    const url = window.location.pathname.split('/');
    const id = url[url.length - 1];
    fetchTema(id);
  }, []);

  const handleSubmit = async () => {
    const id = get(match, 'params.id');

    formValues.values = {
      ...formValues.values,
      external_id: id,
      descricao: convertedText,
      codigo: 1,
      fila_supervisor: 1
    };
    try {
      await Axios.post(
        `${API_HOST}/redacao_temas/temas/${id}/create_projeto`,
        formValues.values
      ).then(() => {
        toast.success('Alterações realizadas com sucesso!');
        setErrors([]);
      });
      // window.location.href = `/redacao/temas-redacoes`;
    } catch (error) {
      const status = get(error, 'response.status');

      if (status === 400) {
        const errors = get(error, 'response.data');
        setErrors(errors);
        renderErrorToast(errors);
      }
    }
  };

  const renderError = (error) => {
    return (
      <p key={error} className="text-danger" style={{ fontSize: '0.8rem' }}>
        {error}
      </p>
    );
  };

  const handleCancel = async () => {
    window.location.href = `/redacao/temas-redacoes`;
  };

  return (
    tema.length !== 0 && (
      <div
        className="container"
        style={{ background: '#FAFAFB', marginBottom: '12rem' }}
      >
        <div style={{ background: '#fff' }}>
          <div className="col-md-12 mt-2">
            <NavBreadCrumb currentPath={tema.nome} hasBackslash={false} />
          </div>
          <FormContainer onChange={(formState) => setFormValues(formState)}>
            <div className="row p-2 w-100">
              <div className="col-md-12 mb-4">
                <h2
                  style={{
                    color: '#727780',
                    marginTop: '1rem',
                    marginBottom: '0.8rem',
                    fontStyle: 'normal'
                  }}
                >
                  Configurações para o projeto
                </h2>
              </div>
              <div
                className={classnames('col-md-6', {
                  'has-error': get(errors, 'titulo')
                })}
              >
                <InputText styleProjeto label="Título" field="titulo" />
                {renderError(get(errors, 'titulo'))}
              </div>
              <div className="col-md-6">
                <InputText
                  styleProjeto
                  label="Descrição"
                  field="descricao"
                  required={true}
                  value={convertedText}
                  onChange={setConvertedText}
                />
              </div>
              <div className="col-md-6">
                <IputDateMaterialUI
                  label="Data e hora de início das correções"
                  field="data_inicio"
                />
              </div>
              <div className="col-md-6">
                <IputDateMaterialUI
                  label="Data e hora de término das correções"
                  field="data_termino"
                />
              </div>
              <div className="col-md-6">
                <InputNumber
                  styleProjeto
                  label="Quantidade mínima de correções por dia"
                  field="min_correcoes_dia"
                />
              </div>
              <div
                className={classnames('col-md-6', {
                  'has-error': get(errors, 'max_correcoes_dia')
                })}
              >
                <InputNumber
                  styleProjeto
                  required={true}
                  label="Quantidade máxima de correções por dia"
                  field="max_correcoes_dia"
                />
                {renderError(get(errors, 'max_correcoes_dia'))}
              </div>
              <div className="col-md-6">
                <InputNumber
                  styleProjeto
                  label="Quantidade mínima de correções para uma redação"
                  field="fila_prioritaria_min"
                />
              </div>
              <div
                className={classnames('col-md-6', {
                  'has-error': get(errors, 'fila_prioritaria')
                })}
              >
                <InputNumber
                  styleProjeto
                  required={true}
                  label="Quantidade máxima de correções para uma redação"
                  field="fila_prioritaria"
                />
                {renderError(get(errors, 'fila_prioritaria'))}
              </div>
              <div
                className={classnames('col-md-6', {
                  'has-error': get(errors, 'limite_nota_final')
                })}
              >
                <InputDecimal
                  required={true}
                  label="Limite de discrepância nas notas entre correções"
                  field="limite_nota_final"
                />
                {renderError(get(errors, 'limite_nota_final'))}
              </div>
              <div
                className={classnames('col-md-6', {
                  'has-error': get(errors, 'limite_nota_competencia')
                })}
              >
                <InputDecimal
                  required={true}
                  label="Limite Nota competência"
                  field="limite_nota_competencia"
                />
                {renderError(get(errors, 'limite_nota_competencia'))}
              </div>
              {/* <span>Terá correção com nota soberana?</span>
              <div className="col-md-12 d-flex justify-content-between">
                <InputCheckbox required label="Sim" field="sim" />
                <InputCheckbox required label="Não" field="nao" />
              </div>
              <div className="col-md-12">
                {get(formValues, 'values.sim') && (
                  <InputNumber
                    styleProjeto
                    label="Qual Correção prevalecerá?"
                    field="fila_soberana"
                  />
                )}
              </div> */}
              <hr style={{ border: '1px solid #e8e8e8', width: '100%' }} />
              <div className="col-md-12">
                <h2
                  style={{
                    color: '#727780',
                    marginTop: '1rem',
                    marginBottom: '1.1rem',
                    fontWeight: 700
                  }}
                >
                  Configurações para a Vista de prova
                </h2>
              </div>
              <div className="col-md-6">
                <IputDateMaterialUI
                  label="Data e hora de início da vista de prova"
                  field="data_inicio_vista"
                />
              </div>
              <div className="col-md-6">
                <IputDateMaterialUI
                  label="Data e hora de término da vista de prova"
                  field="data_termino_vista"
                />
              </div>
              <hr style={{ border: '1px solid #e8e8e8', width: '100%' }} />
              {/* <div className="col-md-12">
                <h2
                  style={{
                    color: '#727780',
                    marginTop: '1rem',
                    marginBottom: '1.1rem',
                    fontWeight: 700
                  }}
                >
                  Critérios de Avaliação da correção
                </h2>
                <div className="col-md-12">
                  <span>A correção será por seta de desvio ou por nota?</span>
                  <InputCheckbox
                    required
                    label="Setas de desvio"
                    field="setas_desvio"
                  />
                  <InputCheckbox required label="Nota" field="nota" />
                </div>
                <div
                  className={classnames('col-md-6', {
                    'has-error': get(errors, 'nota_inicial')
                  })}
                >
                  <InputDecimal
                    required={true}
                    label="Valor total da redação"
                    field="nota_inicial"
                  />
                  {renderError(get(errors, 'nota_inicial'))}
                </div>
              </div> */}
            </div>
          </FormContainer>
          <div className="p-4 d-flex justify-content-between">
            <button
              style={{
                padding: '0.5rem 0.8rem 0.5rem 0.8rem',
                color: '#f5f5f5',
                fontWeight: 700,
                width: '120px',
                fontSize: '16px',
                borderRadius: '12px',
                border: '1px solid #0047b6',
                color: '#0047b6',
                boxShadow: '0px 0px 8px 1px rgba(0, 0, 0, 0.03)'
              }}
              onClick={handleCancel}
            >
              Cancelar
            </button>

            <button
              style={{
                padding: '0.5rem 0.8rem 0.5rem 0.8rem',
                color: '#f5f5f5',
                fontWeight: 700,
                fontSize: '16px',
                borderRadius: '10px',
                background: '#0047b6',
                border: 'none',
                boxShadow: '0px 0px 8px 1px rgba(0, 0, 0, 0.03)'
              }}
              type="submit"
              onClick={handleSubmit}
            >
              Criar projeto
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default withRouter(CreateProjetoCorrecao);
